const orderStates = ['-1', '0', '1', '2', '3', '4']

export function orderStateTab(state) {
  const value = String(state)
  return orderStates.includes(value) ? value : null
}

export function virtualOrderTarget(row) {
  const state = orderStateTab(row.orderState)
  if (!row.orderNum || state === null) return null
  return { path: '/order/goodsorder', query: { orderNum: String(row.orderNum), orderState: state } }
}
